/**
 * Whether the caret is already somewhere that takes text, where `/` is a character.
 *
 * Its own module, registering no catalogue area: the shell's bar, in the launch entry, asks it too,
 * and `ViewSearchField` registers `viewSearch`, which the entry does not carry
 * (`i18n/entryAreas.guard.test.ts`).
 */
export function takesText(target: EventTarget | null): boolean {
  if (!(target instanceof HTMLElement)) return false;
  if (target.isContentEditable) return true;
  if (target instanceof HTMLTextAreaElement || target instanceof HTMLSelectElement) return true;
  if (!(target instanceof HTMLInputElement)) return false;
  return !['button', 'checkbox', 'radio', 'submit', 'reset', 'range', 'color', 'file'].includes(
    target.type,
  );
}
